import { AppShellPlayground } from "../AppShellPlayground";
import { AccordionPlayground } from "../AccordionPlayground";
import { BreadcrumbsPlayground } from "../BreadcrumbsPlayground";
import { CardPlayground } from "../CardPlayground";
import { CollapsiblePlayground } from "../CollapsiblePlayground";
import { DividersPlayground } from "../DividersPlayground";
import { GridPlayground } from "../GridPlayground";
import { OverflowListPlayground } from "../OverflowListPlayground";
import { PageSectionPlayground } from "../PageSectionPlayground";
import { ResizablePanelsPlayground } from "../ResizablePanelsPlayground";
import { SectionPlayground } from "../SectionPlayground";
import { SideNavPlayground } from "../SideNavPlayground";
import { StacksPlayground } from "../StacksPlayground";
import { StepsPlayground } from "../StepsPlayground";
import { TabsPlayground } from "../TabsPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const structureLayoutEntries: PlaygroundComponentEntry[] = [
    {
        id: "steps",
        label: "Steps",
        description: "Step indicator for multi-step flows.",
        group: "components",
        render: () => <StepsPlayground />,
    },
    {
        id: "collapsible",
        label: "Collapsible",
        description: "Expandable content region.",
        group: "components",
        render: () => <CollapsiblePlayground />,
    },
    {
        id: "page-section",
        label: "Page section",
        description: "Titled page section wrapper.",
        group: "components",
        render: () => <PageSectionPlayground />,
    },
    {
        id: "app-shell",
        label: "App shell",
        description:
            "Slot-based application shell: navigation, header, banner, sub-navigation, aside.",
        group: "components",
        render: () => <AppShellPlayground />,
    },
    {
        id: "card",
        label: "Card",
        description: "Content card container.",
        group: "components",
        render: () => <CardPlayground />,
    },
    {
        id: "dividers",
        label: "Dividers",
        description: "Horizontal rules and separators.",
        group: "components",
        render: () => <DividersPlayground />,
    },
    {
        id: "resizable-panels",
        label: "Resizable panels",
        description: "Split panels with draggable divider.",
        group: "components",
        render: () => <ResizablePanelsPlayground />,
    },
    {
        id: "stacks",
        label: "Stacks",
        description: "Horizontal, vertical, and flex layout stacks.",
        group: "components",
        render: () => <StacksPlayground />,
    },
    {
        id: "grid",
        label: "Grid",
        description: "Row/column grid primitives.",
        group: "components",
        render: () => <GridPlayground />,
    },
    {
        id: "tabs",
        label: "Tabs",
        description:
            "Base UI tabs navigation with animated indicator, disabled tabs, and panels.",
        group: "components",
        render: () => <TabsPlayground />,
    },
    {
        id: "accordion",
        label: "Accordion",
        description: "Base UI accordion with single or multiple open panels.",
        group: "components",
        render: () => <AccordionPlayground />,
    },
    {
        id: "breadcrumbs",
        label: "Breadcrumbs",
        description:
            "Figma-aligned breadcrumb trail on Link: router, anchor or step items, static ancestors, and a current item that truncates with a tooltip.",
        group: "ready-components",
        render: () => <BreadcrumbsPlayground />,
    },
    {
        id: "side-nav",
        label: "Side nav",
        description:
            "Figma-aligned main navigation: header, sticky top rows, collapsible sections, expandable rows with sub-items, click to hide and show, and overlay mode.",
        group: "ready-components",
        render: () => <SideNavPlayground />,
    },
    {
        id: "overflow-list",
        label: "Overflow list",
        description: "List that collapses overflowing items.",
        group: "components",
        render: () => <OverflowListPlayground />,
    },
    {
        id: "section",
        label: "Section",
        description: "Titled content section.",
        group: "components",
        render: () => <SectionPlayground />,
    },
];
